module.exports = __webpack_public_path__ + "img/stx.ecfc86a7.svg";